export default __webpack_public_path__ + "static/4-d6524467a70526d6bfd558ff4557e2e7.jpeg";